class DrawerComponent extends HTMLElement {
  isOpen = false;
  drawer = null;
  theme = null;
  id = null;
  static instances = new Map();

  static get observedAttributes() {}

  constructor() {
    super();
    this.id = this.getAttribute('id');
    try {
      const headerControl = document.querySelector('header-control');
      this.theme = headerControl
        ? headerControl.getAttribute('data-theme')
        : 'light';
    } catch (error) {
      this.theme = 'light';
    }
  }

  connectedCallback() {
    if (!this.drawer) {
      this.createDrawer();
    }
    DrawerComponent.instances.set(this.id, this);
  }

  disconnectedCallback() {
    this.cleanup();
    DrawerComponent.instances.delete(this.id);
  }

  createDrawer() {
    // body创建drawer
    this.drawer = document.createElement('div');
    this.drawer.classList.add(`header-drawer-${this.theme}`);
    Object.assign(this.drawer.style, {
      position: 'fixed',
      top: '0',
      right: '0',
      bottom: '0',
      width: '100%',
      maxWidth: '100vw',
      height: '100%',
      zIndex: '1000',
      backgroundColor: 'rgb(var(--color-background, 255, 255, 255))',
      transform: 'translateX(100%)',
      transition: 'transform 0.3s ease',
      boxShadow: '-2px 0 10px rgba(0, 0, 0, 0.1)',
      overflowY: 'auto',
    });

    this.drawer.innerHTML = this.innerHTML;
  }

  updateDrawerState() {
    if (!this.isOpen) {
      this.open();
    } else {
      this.close();
    }
  }

  open() {
    if (this.isOpen) return;

    this.isOpen = true;

    document.body.appendChild(this.drawer);

    requestAnimationFrame(() => {
      this.drawer.style.transform = 'translateX(0)';
      const selectRegion = getCookie('PreferredCountry');
      if (!selectRegion) {
        setCookie('PreferredCountry', 'United States');
      } else {
        updateCountryWord(selectRegion);
      }
    });

    // 防止背景滚动
    document.body.style.overflow = 'hidden';
    window.zzLockBodyScroll && window.zzLockBodyScroll();

    this.dispatchEvent(
      new CustomEvent('drawer:open', {
        bubbles: true,
        detail: { drawer: this },
      })
    );
  }

  close() {
    if (!this.isOpen) return;

    this.isOpen = false;

    this.drawer.style.transform = 'translateX(100%)';

    document.body.style.overflow = '';
    window.zzUnlockBodyScroll && window.zzUnlockBodyScroll();

    setTimeout(() => {
      if (this.drawer?.parentNode) {
        document.body.removeChild(this.drawer);
      }
    }, 300);

    this.dispatchEvent(
      new CustomEvent('drawer:close', {
        bubbles: true,
        detail: { drawer: this },
      })
    );
  }

  toggleDrawer() {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }

    this.dispatchEvent(
      new CustomEvent('drawer:toggle', {
        bubbles: true,
        detail: {
          drawer: this,
          isOpen: this.isOpen,
        },
      })
    );
  }

  cleanup() {
    this.close();
    if (this.drawer) {
      this.drawer.remove();
    }
  }
}

if (!customElements.get('mobile-menu')) {
  customElements.define('mobile-menu', DrawerComponent);
}

function handleOpenSubMenu(event) {
  const el = $(event.currentTarget).next('mobile-menu')[0];
  el.toggleDrawer();
}
function handleCloseAllMenu(event) {
  DrawerComponent.instances.forEach((instance) => {
    instance.close();
  });
}

function handleBackSubMenu(id) {
  DrawerComponent.instances.forEach((instance, key) => {
    if (key === id) {
      instance.close();
    }
  });
}
